import { defineMessages, useIntl } from 'react-intl';

import CalmGradientText from '../CalmGradientText';
import Author from './Author';
import { Container } from './styles';

const messages = defineMessages({
	header: {
		id: 'book.authors.header',
		defaultMessage: 'Meet the Authors',
		description: 'Heading to introduce authors of book',
	},
});

const Authors = () => {
	const { formatMessage } = useIntl();
	return (
		<Container>
			<CalmGradientText text={formatMessage(messages.header)} />
			<div>
				<Author name="Michael Acton Smith" handle="acton" />
				<Author name="Alex Tew" handle="tewy" />
			</div>
		</Container>
	);
};

export default Authors;
